import {
  RewardListPageKey,
  RewardModalKey,
  RewardSellingModalKey,
  StatusTextKey,
  VoucherCodeSetupPageKey
} from '../../TModules';

export const translations = {
  [RewardListPageKey]: {
    Reward: 'Prämie',
    List: 'Liste',
    All: 'Alle',
    Draft: 'Entwurf',
    Pending: 'Ausstehend',
    Scheduled: 'Geplant',
    Active: 'Aktiv',
    Ended: 'Beendet',
    Inactive: 'Inaktiv',
    TransactionIssued: 'Transaktion ausgestellt',
    Private: 'Privat',
    System: 'System',
    SellingFast: 'Schnell ausverkauft',
    SoldOut: 'Ausverkauft',
    Subtitle: 'Untertitel',
    Stackable: 'Stapelbar',

    Name: 'Name',
    Merchant: 'Händler',
    Status: 'Status',
    Balance: 'Guthaben',
    RedemptionBalance: 'Einlöse-Guthaben',
    RewardRedeemed: 'Eingelöst',
    VoidedReward: 'Ungültig',
    SellingFrom: 'Verkauf ab',
    SellingTo: 'Verkauf bis',
    Actions: 'Aktionen',
    RequestType: 'Anforderungstyp',
    Comments: 'Kommentare',
    LastUpdated: 'Zuletzt aktualisiert',

    CreateNew: 'Neu erstellen',
    Edit: 'Bearbeiten',
    DownloadCodes: 'Codes herunterladen',
    DuplicateReward: 'Prämie duplizieren',
    Deactivate: 'Deaktivieren',
    Activate: 'Aktivieren',
    DownloadDepletedCodes: 'Erschöpfte Codes herunterladen',
    UnassginedVouchers: 'Nicht zugewiesene Gutscheine',
    ReplinishVouchers: 'Gutscheine auffüllen',
    Deplete: 'Erschöpfen',
    Replinish: 'Auffüllen',
    AppendBudget: 'Budget anhängen',
    Approve: 'Genehmigen',
    RequestDeletion: 'Löschung anfordern',
    PublishNew: 'Neu veröffentlichen',
    Reactivate: 'Reaktivieren',
    NA: 'N.A',

    Type: 'Typ',
    RewardName: 'Prämienname',
    Description: 'Beschreibung',
    StepsToRedeem: 'Schritte zum Einlösen',
    SellingPeriod: 'Verkaufszeitraum',
    ActiveAt: 'Aktiv um',
    TermsAndConditions: 'Allgemeine Geschäftsbedingungen',
    RiskDisclaimer: 'Risikohinweis',
    BrandName: 'Markenname',
    Brands: 'Marken',
    Tags: 'Tags',
    Categories: 'Kategorien',
    Labels: 'Labels',
    Catalogues: 'Kataloge',
    UploadedPhotos: 'Hochgeladene Fotos',
    UploadedPhoto: 'Hochgeladenes Foto',
    UploadMultipleImages: 'Mehrere Bilder hochladen',
    UploadAFile: 'Datei hochladen',
    WhereCanThisbeRewardDisplayed: 'Wo kann diese Prämie angezeigt werden?',
    RewardCost: 'Prämienkosten',
    SellingPrice: 'Verkaufspreis',
    CustomFields: 'Benutzerdefinierte Felder',

    AudienceInfo: 'Zielgruppeninformationen',
    AudienceAttributes: 'Zielgruppenattribute',
    AudienceList: 'Zielgruppenliste',
    NoFiltersSelected: 'Keine Filter ausgewählt',
    NoListSelected: 'Keine Liste ausgewählt',

    RewardsMechanics: 'Prämienmechanik',
    CodeType: 'Code-Typ',
    Code: 'Code',
    VoucherCodeType: 'Gutscheincode-Typ',
    RewardIssuanceLimit: 'Prämienausgabelimit',
    TotalRedemptionLimit: 'Gesamteinlöselimit',
    RedemptionLimitsPerPeriod: 'Einlöselimits pro Zeitraum',
    RewardIssuancePerPeriodLimit: 'Prämienausgabelimit pro Zeitraum',
    UserLimits: 'Benutzerlimits',
    UserLimitsPerPeriod: 'Benutzerlimits pro Zeitraum',
    VoucherValidity: 'Gültigkeit des Gutscheins',
    RedemptionType: 'Einlöseart',
    GiftingOption: 'Geschenkoption',

    Public: 'Öffentlich',
    MainBodyText: 'Haupttext',
    AddAccordion: 'Akkordeon hinzufügen',

    Next: 'Weiter',
    Cancel: 'Abbrechen',
    Browse: 'Durchsuchen',
    Back: 'Zurück',
    SaveAsDraft: 'Als Entwurf speichern',
    Launch: 'Starten',
    Publish: 'Veröffentlichen',
    Save: 'Speichern',
    ImportReward: 'Prämie importieren',
    PerIssuance: 'Pro Ausgabe',
    ConversionMetric: 'Konversionsmetrik',
    CostPerIssued: 'Kosten pro Ausgabe',
    BudgetAllocation: 'Budgetzuordnung',
    Inventory: 'Inventar',
    ActivationDate: 'Aktivierungsdatum',
    StartDate: 'Startdatum',
    EndDate: 'Enddatum',
    OperatingDays: 'Betriebstage',
    From: 'Von',
    DiscountStartDate: 'Rabatt-Startdatum',
    DiscountEndDate: 'Rabatt-Enddatum',
    ID: 'ID',
    CashValue: 'Barwert',

    PointsValue: 'Punktewert',
    LoyaltyProgram: 'Treueprogramm',
    Identifier: 'Identifikator',
    Action: 'Aktion',
    ThisRewardsIsCurrentlyFREE: 'Diese Prämie ist derzeit KOSTENLOS',
    ReActivateSellingPrice:
      'Aktivieren Sie einen Verkaufspreis unten erneut oder fügen Sie einen neuen hinzu',
    AddSellingPrice: 'Verkaufspreis hinzufügen',
    EditSellingPrice: 'Verkaufspreis bearbeiten',
    HowDoYouValueYourRewards: 'Wie bewerten Sie Ihre Prämien?',
    CostPrice: 'Kostenpreis',
    SocialMedia: 'Soziale Medien',
    Title: 'Titel',
    Image: 'Bild',
    iOSAppLink: 'iOS-App-Link',
    AndroidAppLink: 'Android-App-Link',
    WebLink: 'Weblink',
    AddCustomField: 'Benutzerdefiniertes Feld hinzufügen',
    CustomField: 'Benutzerdefiniertes Feld',
    TypeInFieldName: 'Feldnamen eingeben',
    TypeInFieldValue: 'Feldwert eingeben',
    SelectCodeType: 'Code-Typ auswählen',
    TypeOfCode: 'Code-Typ',
    GenericCode: 'Allgemeiner Code',
    QRCode: 'QR-Code',
    BarCode: 'Barcode',
    URL: 'URL',
    SelectFile: 'Datei auswählen',
    ChooseFile: 'Datei auswählen',
    DownloadSample: 'Beispiel herunterladen (Akzeptiertes Format: nur .xlsx/.csv-Dateien)',
    ErrorParsingTheFile: 'Fehler beim Analysieren der Datei',
    SelectStashReward: 'Stash-Belohnung Auswählen',
    RewardHasToBeLinkedToAStashReward:
      'Die Belohnung Muss Mit Einer Stash-Belohnung Verknüpft Sein',
    InventorySource: 'Inventarquelle',

    Limits: 'Limits',
    IssueAMaximumOf: 'Maximal ausgeben',
    RewardsPer: 'Prämien pro',
    Second: 'Sekunde',
    Minutes: 'Minuten',
    Hours: 'Stunden',
    Days: 'Tage',
    Weeks: 'Wochen',
    Months: 'Monate',
    Month: 'Monat',
    Year: 'Jahr',
    ALifetimeLimitMustBeSet: 'Ein Lebenszeitlimit muss festgelegt werden',
    TheMaximumLimitIs: 'Das maximale Limit beträgt',
    TheLimitMustBeMoreThan: 'Das Limit muss mehr als',
    DisplayEvenWhenIssuanceLimitIsReached: 'Auch anzeigen, wenn das Ausgabelimit erreicht ist',
    RewardRedemptionLimit: 'Prämieneinlöselimit',
    LimitRedemptionsTo: 'Einlösungen begrenzen auf',
    PleaseFillInTheLimitRedemptionToValue: 'Bitte geben Sie den Wert für das Einlöselimit ein',
    PleaseFillInTheRedemptionIntervalUnits:
      'Bitte geben Sie die Einheiten des Einlöserintervalls ein',

    UserLimit: 'Benutzerlimit',
    UserLimitPerPeriod: 'Benutzerlimit pro Zeitraum',
    DisplayEvenWhenLimitIsReached: 'Auch anzeigen, wenn das Limit erreicht ist',
    ValidityPeriod: 'Gültigkeitsdauer',
    AfterDateOfPurchaseDate: 'Nach dem Kaufdatum',
    SelectType: 'Typ auswählen',
    Period: 'ZEITRAUM',
    IssuanceDate: 'AUSGABEDATUM',
    EndOfMonth: 'MONATSENDE',
    RedemptionOutcomes: 'Einlöseergebnisse',
    AddOutcome: 'Ergebnis hinzufügen',
    Online: 'ONLINE',
    Offline: 'OFFLINE',
    MerchantPIN: 'HÄNDLER-PIN',
    Pin: 'PIN',
    APIRedemption: 'API-EINLÖSUNG',
    SetCountdown: 'Countdown einstellen',
    SelectGiftingOption: 'Geschenkoption auswählen',
    ScheduleLaunch: 'Start planen',
    MapYourRewardTo: 'Ordnen Sie Ihre Prämie zu',
    Include: 'Einschließen',
    SneakPeek: 'Vorschau',
    SelectLoyaltyProgram: 'Wählen Sie Ihr Treueprogramm',
    PickAudienceList: 'Zielgruppenliste auswählen',
    UploadNewList: 'Neue Liste hochladen',
    AcceptedFormat: 'Akzeptiertes Format: nur .xlsx/.csv-Dateien',
    AudienceNotInList: 'Zielgruppe nicht in der Liste?',
    PleaseSelectAMerchant: 'Bitte wählen Sie einen Händler',
    StartDateEndDateRequired: 'Start- und Enddatum erforderlich',
    EndDateCannotBeBeforeStartDate: 'Enddatum kann nicht vor dem Startdatum liegen',
    RewardHasToBeLinkedToAnInventoryItem:
      'Die Belohnung muss mit einem Inventar-Artikel verknüpft sein',
    BatchNeedsToBeSelected: 'Ein Bestandspaket muss ausgewählt werden',
    NumberOfVouchersMustBeGreaterOrEqual1: 'Die Anzahl der Gutscheine muss ≥ 1 sein',
    VoucherCodesCannotBeEmpty: 'Gutscheincodes dürfen nicht leer sein',
    Batches: 'Chargen',
    MerchantName: 'Händlername',
    UNASSIGNED_VOUCHER_CODES: 'NICHT ZUGEWIESENE GUTSCHEINSCODES',
    ACTIVE_INVENTORY_BALANCE: 'AKTIVER BESTANDSSALDO',
    OutOf: 'von',
    IncludeFromBatch: 'Aus Charge einbeziehen',
    VoucherCodes: 'Gutscheincodes',
    IncludeAnotherBatch: 'Weitere Charge einbeziehen',
    PrefixForVoucherCode: 'Präfix für Guthabencode',
    LengthOfCode: 'Code Länge',
    CodeFormat: 'Codeformat',
    Total: 'Gesamt',
    PossibleTotalPermutations: 'Mögliche Gesamtanzahl der Permutationen',
    SelectOption: 'Option auswählen',
    RedemptionTypeEditError: 'Sie können den Einlösetyp einer aktiven Belohnung nicht bearbeiten.',
    EnterCallToActionURL: 'Call-to-Action-URL eingeben',
    APIEndpoint: 'API-Endpunkt',
    QueryParamsValue: 'Wert der Abfrageparameter',
    BodyParamsValue: 'Wert der Body-Parameter',
    PleaseSelectRedemptionType: 'Bitte Einlösetyp auswählen',
    PleaseSelectAnAPI: 'Bitte wählen Sie eine API aus',
    Key: 'Schlüssel',
    Value: 'Wert',
    Prefix: 'Präfix',
    Postfix: 'Suffix',
    isRequired: 'ist erforderlich',
    IDENTIFIER: 'KENNUNG',
    PROGRAM: 'PROGRAMM',
    POINTS: 'PUNKTE',
    PRICE: 'PREIS',
    LISTING: 'LISTE',
    Exclude: 'Ausschließen',
    SneakPreview: 'Vorschau',

    ValidityAtLeastOneHour: 'Gültigkeit muss mindestens 1 Stunde betragen',
    ValidFor: 'Gültig für',
    GraceTime: 'Karenzzeit',
    GraceTimeCannotBeNegative: 'Karenzzeit kann nicht negativ sein',
    Yes: 'Ja',
    No: 'Nein',

    RewardInfo: 'Prämieninformationen',
    RewardMechanics: 'Prämienmechanik',
    PendingReward: 'Ausstehende Belohnung',
    AddComment: 'Kommentar hinzufügen',
    ThisRewardIsPendingApproval:
      'Diese Belohnung wartet auf Genehmigung. Alle hinzugefügten Kommentare werden hier angezeigt.',
    ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
    EnterYourCommentHere: 'Geben Sie hier Ihren Kommentar ein',
    DeleteComment: 'Kommentar löschen?',
    CommentDeleted: 'Kommentar gelöscht',
    ErrorDeletingComment: 'Fehler beim Löschen des Kommentars',
    CommentsAdded: 'Kommentare hinzugefügt',
    AreYouSureYouWantToDeleteThisComment:
      'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten',
    RewardMustHaveAName: 'Prämie muss einen Namen haben',
    AllowedFileTypes: 'Erlaubt: .jpg, .png, .svg',
    EitherAniOSOrAndroidOrWebLinkIsRequired:
      'Entweder ein iOS- oder Android- oder Web-Link ist erforderlich',
    Delete: 'Löschen',
    InsertPhoto: 'Bild einfügen',
    SelectImageType: 'Wahlen Sie png, svg, jpeg, oder gif-Bilder',
    Info: 'Info',
    Audience: 'Zielgruppe',
    SelectAudience: 'Zielgruppe auswählen',
    Review: 'Überprüfen',
    Mechanics: 'Mechanik',
    RewardDetails: 'Prämien-Details',
    SelectDate: 'Datum auswählen',
    SelectTime: 'Zeit auswählen',

    PleaseSelectYourBrands: 'Bitte wählen Sie Ihre Marken',
    PleaseSelectYourTags: 'Bitte wählen Sie Ihre Tags',
    PleaseSelectYourCategories: 'Bitte wählen Sie Ihre Kategorien',
    PleaseSelectYourLabels: 'Bitte wählen Sie Ihre Labels',
    PleaseSelectYourCatalogues: 'Bitte wählen Sie Ihre Kataloge',
    PleaseSelectAnOwner: 'Bitte wählen Sie einen Besitzer',
    TypeInYourRewardNameHere: 'Geben Sie hier Ihren Prämiennamen ein',
    TypeInYourSubtitleNameHere: 'Geben Sie hier Ihren Untertitel ein',

    EnglishRewardNameRequired: 'Englischer Prämienname ist erforderlich',
    RewardNameRequired: 'Prämienname ist erforderlich',
    StartDateRequired: 'Startdatum ist erforderlich',
    RewardOwnerRequired: 'Prämienbesitzer ist erforderlich',
    UploadedImagesShouldBeSetAsSection:
      'Hochgeladene Bilder sollten als Abschnitt festgelegt werden',
    DiscountStartDateCannotBeBlank: 'Rabatt-Startdatum darf nicht leer sein',
    DiscountEndDateCannotBeBlank: 'Rabatt-Enddatum darf nicht leer sein',
    DiscountEndDateCannotBeBeforeDiscountStartDate:
      'Rabatt-Enddatum kann nicht vor dem Rabatt-Startdatum liegen',
    RewardPartnerRequired: 'Prämienpartner ist erforderlich',
    ValidityPeriodMustExtendPastSellingPeriod:
      'Der Gültigkeitszeitraum muss über den Verkaufszeitraum hinausgehen.',
    RewardLimitFieldShouldBePositive: 'Das Prämien-Limit-Feld sollte positiv sein',
    RewardLimitPerPeriodFieldShouldBePositive:
      'Das Prämien-Limit pro Zeitraum-Feld sollte positiv sein',
    RewardLimitPerPeriodUnitsRequired: 'Prämien-Limit pro Zeitraum-Einheiten sind erforderlich',
    RewardLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Prämien-Limit pro Zeitraum-Einheiten sollten größer als Null sein',
    RewardLimitPerPeriodFieldRequired: 'Das Prämien-Limit pro Zeitraum-Feld ist erforderlich',
    RewardLimitPerPeriodFieldShouldBeMoreThanZero:
      'Das Prämien-Limit pro Zeitraum-Feld sollte größer als Null sein',
    UserLimitFieldShouldBePositive: 'Das Benutzer-Limit-Feld sollte positiv sein',
    UserLimitPerPeriodFieldShouldBePositive:
      'Das Benutzer-Limit pro Zeitraum-Feld sollte positiv sein',
    UserLimitPerPeriodUnitsRequired: 'Benutzer-Limit pro Zeitraum-Einheiten sind erforderlich',
    UserLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Benutzer-Limit pro Zeitraum-Einheiten sollten größer als Null sein',
    UserLimitPerPeriodFieldRequired: 'Das Benutzer-Limit pro Zeitraum-Feld ist erforderlich',
    RedemptionIntervalUnitsOrLimitRedemptionToValueShouldBeMoreThanZero:
      'Einlöse-Intervall-Einheiten oder Einlöse-Limit zu Wert sollten größer als Null sein',
    ActivationStartDate: 'Aktivierungsdatum',
    SetActivationStartDate: 'Aktivierungsdatum setzen',
    ApproveReward: 'Prämie genehmigen',
    SubmitDeletionRequest: 'Löschanfrage senden',
    AreYouSureYouWantToApproveThisReward:
      'Sind Sie sicher, dass Sie diese Prämie genehmigen möchten',
    ThisActionCannotBeUndone: 'Diese Aktion kann nicht rückgängig gemacht werden',
    ThisRewardIsPendingApprovalAreYouSureYouWantToDeleteIt:
      'Diese Prämie wartet auf Genehmigung. Sind Sie sicher, dass Sie sie löschen möchten',
    OnceTheDeletionIsApprovedThisRewardWillNotBeAvailableAndYouWillNeedToCreateItAgain:
      'Sobald die Löschung genehmigt ist, ist diese Prämie nicht mehr verfügbar und Sie müssen sie erneut erstellen.',
    SetAs: 'Als festlegen',
    Day: 'Tag',
    PERIOD: 'ZEITRAUM',
    To: 'bis',
    ISSUANCE_DATE: 'AUSGABEDATUM',
    END_OF_MONTH: 'MONATSENDE',
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    PIN: 'PIN',
    Every: 'Jede',
    OpenTimeIsRequired: 'Öffnungszeit ist erforderlich',
    CloseTimeIsRequired: 'Schließzeit ist erforderlich',
    CloseTimeCannotBeBeforeOrSameAsOpenTime:
      'Die Schließzeit darf nicht vor oder gleich der Öffnungszeit liegen',

    RewardOutcomesTable: {
      OutcomeType: 'Ergebnistyp',
      Value: 'Wert',
      LoyaltyProgram: 'Treueprogramm',
      Action: 'Aktion',
      SetOutcomeValue: 'Ergebniswert festlegen',
      Delete: 'Löschen'
    }
  },
  [VoucherCodeSetupPageKey]: {
    NoCode: 'Kein Code',
    Single: 'Einzeln',
    SystemGenerated: 'Systemgeneriert',
    UserUpload: 'Benutzer-Upload',
    Inventory: 'Inventar',
    Stash: 'Vorrat',
    VoucherCodeSetup: 'Gutscheincode-Einrichtung',
    SelectCodeType: 'Code-Typ auswählen',
    None: 'Keine'
  },
  [RewardSellingModalKey]: {
    SelectLoyaltyProgram: 'Wählen Sie Ihr Treueprogramm',
    SelectTier: 'Wählen Sie Tier',
    Cash: 'Geld',
    PointsRegularPrice: 'Punkte (normaler Preis)',
    PointsDiscountPrice: 'Punkte (rabattierter Preis)',
    egHundred: 'z.B. 100',
    Optional: 'Optional',
    SelectGLAccount: 'Wählen Sie GL-Konto',
    GLAccountType: 'GL-Kontotyp',
    GLAccountName: 'GL-Kontoname',
    EitherPriceOrPointsIsRequired: 'Entweder Preis oder Punkte ist erforderlich',
    DiscountPriceCannotBeMoreThanRegularPrice:
      'Der Rabattpreis darf nicht höher sein als der reguläre Preis',
    DiscountPriceShouldBeAtLeast: 'Der Rabattpreis muss mindestens 1 sein',
    Issue: 'Problem',
    Value: 'Wert',
    Points: 'Punkte'
  },
  [StatusTextKey]: {
    active: 'Aktiv',
    inactive: 'Inaktiv',
    draft: 'Entwurf',
    processing: 'Verarbeitung',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    scheduled: 'Programmiert',
    redeemed: 'Eingelöst',
    ended: 'Beendet',
    failed: 'Fehlgeschlagen',
    fail: 'Fehlschlagen',
    expired: 'Abgelaufen',
    public: 'Öffentlich',
    success: 'Erfolgreich',
    completed: 'Abgeschlossen',
    timeout: 'Zeitüberschreitung',
    system: 'System',
    CreatingReward: 'Belohnung Wird Erstellt...',
    RewardSubmittedForApproval: 'Belohnung Zur Genehmigung Eingereicht',
    FailedToCreateReward: 'Erstellung Der Belohnung Fehlgeschlagen!',
    RewardApproval: 'Belohnungsgenehmigung...',
    ApprovalSuccess: 'Genehmigung Erfolgreich...',
    FailedToApprove: 'Genehmigung Fehlgeschlagen!',
    DeactivationRequestSubmittedForApproval: 'Deaktivierungsanfrage Zur Genehmigung Eingereicht!',
    DeactivationSuccess: 'Deaktivierung Erfolgreich...',
    FailedToDeactivate: 'Deaktivierung Fehlgeschlagen!',
    RewardDeactivation: 'Belohnungsdeaktivierung...',
    RewardReactivation: 'Belohnungsreaktivierung...',
    ReactivationSuccess: 'Reaktivierung Erfolgreich...',
    ReactivationRequestSubmittedForApproval: 'Reaktivierungsanfrage Zur Genehmigung Eingereicht!',
    FailedToReactivate: 'Reaktivierung Fehlgeschlagen!',
    Processing: 'Wird Verarbeitet...',
    FailedToUpdateReward: 'Aktualisierung Der Belohnung Fehlgeschlagen!',
    ErrorLoadingRewards: 'Fehler Beim Laden Der Belohnungen!',
    ErrorLoadingTags: 'Fehler Beim Laden Der Tags!',
    ErrorLoadingBrands: 'Fehler Beim Laden Der Marken!',
    ErrorLoadingAudiences: 'Fehler Beim Laden Der Zielgruppenliste!',
    SubmittingData: 'Daten Werden Gesendet...',
    FileUploadSuccess: 'Datei Erfolgreich Hochgeladen',
    DuplicatingReward: 'Belohnung Wird Dupliziert...',
    FailedToDuplicate: 'Duplizierung Fehlgeschlagen!',
    FailedToLoadData: 'Daten Laden Fehlgeschlagen!',
    CouldNotRetrieveRewards: 'Belohnungen Konnte Nicht Abgerufen Werden!',
    ErrorObtainingPartnerDetails: 'Fehler Beim Abrufen Der Partnerdetails!',
    ErrorLoadingMerchants: 'Fehler Beim Laden Der Händler!',
    ErrorLoadingLoyaltyList: 'Fehler Beim Laden Der Treueliste!'
  },

  [RewardModalKey]: {
    CurrentTotalRewardLimit: 'Aktuelles Gesamtes Belohnungslimit',
    ReplenishVoucherCodesAndLimits: 'Gutscheincodes Und Limits Auffüllen',
    DepleteVoucherCodesAndLimits: 'Gutscheincodes Und Limits Reduzieren',
    Replenish: 'Auffüllen',
    Deplete: 'Reduzieren',
    Depleting: 'Wird Reduziert',
    Replenishing: 'Wird Aufgefüllt',
    UploadNewVoucherCodes: 'Neue Gutscheincodes Hochladen',
    ClickOrDragFileToUpload: 'Klicken Oder Datei Zum Hochladen Hierher Ziehen',
    DepleteMustBeGreaterThanZero: 'Reduzierung Muss Größer Als Null Sein.',
    DepletingReplenished: 'Reduzierung Aufgefüllt',
    SuccessfullyReplenished: 'Erfolgreich Aufgefüllt',
    ThereAreDuplicatedCodes: 'Es Gibt {{count}} Doppelte Codes.',
    DownloadDuplicatedCodes: 'Doppelte Codes Herunterladen',
    RewardLimitStatus: '{{value}} von {{total}} Belohnungslimit',
    ThereAreDepletedCodes: 'Es Gibt {{depleted_count}} Erschöpfte Codes.',
    DownloadDepletedCodes: 'Erschöpfte Codes Herunterladen',
    DownloadLogFile: 'Protokolldatei Herunterladen',
    YouHaveDuplicateVoucherCodes:
      'Sie Haben {{duplicates_count}} Doppelte Gutscheincodes. Bitte Überprüfen Sie Ihre Datei Und Laden Sie Sie Erneut Hoch.'
  }
};
